import React from 'react';
import HelpContent from './HelpContent';
import TransporteNoMotorizado from 'img/particion_bicicleta.PNG';

const TransporteNoMotorizadoHelp = () => (
  <HelpContent>
    <h1>Transporte No Motorizado</h1>
    <p>
    Esta medida analiza el impacto de la promoción de los usos de transporte no motorizado en la reducción de emisiones de GEI. La planificación y desarrollo 
    de las ciudades deberá considerar la integración de estas formas de transporte, tales como el uso de bicicleta y la caminata.
    </p>
    <p>
     La medida se modela como una disminución de la demanda pasajero-kilómetro en vehiculos livianos, medianos y buses. 
     A nivel internacional se observan que existen ciudades con políticas de masificación del transporte en bicicleta. 
     En un número importante de ciudades la participación modal supera el 20% y en las ciudades de mayor partición el uso de la bicicleta incluso alcanza incluso el 45%. 
     La siguiente muestra la participación modal del modo de transporte bicicleta para distintas ciudades del mundo.
     </p>

     <img src={TransporteNoMotorizado} alt="Particion modal bicicleta" />
    <label>Figura: Participación de viajes en modo bicicleta. Fuente: Elaboración propia a partir de información obtenida 
    en http://www.cityclock.org/urban-cycling-mode-share/#.VLZ83PmG8vw</label>
  
    <p>
    <strong>Trayectoria 1:</strong>
    </p>
    <p>
    Vehículos livianos: reducción de demanda en 0,3% en 2025 hasta llegar a una reducción de 0,8% en 2030 manteniendo este porcentaje constante hasta 2050.
    </p>
    <p>
    Vehículos medianos: reducción de demanda en 0,5% en 2025 hasta llegar a una reducción de 1,1% en 2030 manteniendo este porcentaje constante hasta 2050.
    </p>
    <p>
    Buses: Reducción de demanda en 1,3% en 2025 hasta llegar a una reducción de 3,0% en 2030 manteniendo este porcentaje constante hasta 2050.
    </p>
  </HelpContent>
);

export default TransporteNoMotorizadoHelp;
